// add stuff as you want to use it.

import { CSSProperties } from "react";

type Dimensions = { width: number; height: number };

export type SvgIconProps = Partial<{
  size: number | Dimensions;
  style: CSSProperties;
  disabled: boolean;
}>;

export const dimensions = (
  props: SvgIconProps,
  values?: SvgIconProps
): Dimensions => {
  if (typeof props.size === "number")
    return { width: props.size, height: props.size };
  if (props.size === undefined) {
    if (typeof values?.size === "number")
      return { width: values.size, height: values.size };
    if (values?.size) return values.size;
    return { width: 14, height: 14 };
  }
  return props.size;
};
